export const BUTTON_INTERACTION = {
	NONE: "none",
	APPLY_BUTTON_CLICK: "apply_button_click",
	APPLICATION_START: "application_start",
	APPLICATION_START_WAIT_LIST: "application_start_WL",
	SYLLABUS_DOWNLOAD: "syllabus_download",
	QUIZ_START: "quiz_start",
	CTA_CLICK: "cta_click",
	COURSE_CTA_CLICK: "course_cta_click",
	LINK_CLICK: "link_click",
	MODAL_FORM_BUTTON_CLICK: "hubspot_form_modal_click",
};

export const FAILED_EVENTS = {
	application_start: "application_start_fail",
	syllabus_download: "syllabus_download_fail",
	quiz_start: "quiz_start_fail",
};

export const CTA_TYPES = {
	hash: "hash",
	typeform: "typeform",
	external: "external",
	internal: "internal",
	syllabus: "syllabus",
};

export const GTM_EVENT_TIMEOUT = 6000;
export const WAIT_TIME_FOR_ANALYTICS = 800;

/**
 * CTA events that submit a marketing lead keyed on the user's email address.
 * These are gated on a valid email before any event or API call is fired.
 * Do not add QUIZ_START here: it hits the API but has no email field -
 * createRequest() posts only {uuid, referral, referral2} - so gating it would
 * break the career quiz CTA.
 */
export const EMAIL_LEAD_EVENTS = [
	BUTTON_INTERACTION.APPLICATION_START,
	BUTTON_INTERACTION.APPLICATION_START_WAIT_LIST,
	BUTTON_INTERACTION.SYLLABUS_DOWNLOAD,
];

/**
 * Every CTA event that talks to the backend. Composed from EMAIL_LEAD_EVENTS so a
 * new email lead event only has to be added in one place. Compose in this
 * direction only: deriving EMAIL_LEAD_EVENTS by filtering API_EVENTS would mean a
 * new non-email API event silently gets email-gated and breaks.
 */
export const API_EVENTS = [...EMAIL_LEAD_EVENTS, BUTTON_INTERACTION.QUIZ_START];

export const BUTTON_CLICK_EVENTS = {
	APPLY_BUTTON_CLICK: "apply_button_click",
};
